import styled from "styled-components"
import { Link as LinkRouter } from "react-router-dom"

import {FaTimes} from "react-icons/fa"

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: var(--white);
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({isOpen}) => (isOpen ? "100%" : "0")};
    top: ${({isOpen}) => (isOpen ? "0" : "-100%")};
`;

export const CloseIcon = styled(FaTimes)`
    color: var(--black);
    width: 18px;
    height: 18px;
`;

export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`;

export const SidebarWrapper = styled.div`
    color: var(--white);
`;

export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat (3, 120px);
    text-align: center;

    @media screen and (max-width: 480px){
        grid-template-rows: repeat(3, 100px)
    }
`;

export const SidebarLink = styled(LinkRouter)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    text-decoration: none;
    color: var(--black);
    cursor: pointer;
`;

// export const ColorSidebarLink = styled(SidebarLink)`
//      background: -webkit-linear-gradient(128.12deg, #F72B89 1.03%, #13B7D5 53.11%, #FFE200 100.04%),
//     -webkit-linear-gradient(0deg, #FFFFFF, #FFFFFF);  
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;  
// `;